import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

const RenterField = ({ name, validate }) => (
  <div className="form-group mt-4">
    <div className="custom-control custom-radio custom-control-inline">
      <Field
        type="radio"
        id={`${name}Ind`}
        name={name}
        validate={validate}
        className="custom-control-input"
        component="input"
        value="Person"
      />
      <label className="custom-control-label label" htmlFor={`${name}Ind`}>
        an individual
      </label>
    </div>
    <div className="custom-control custom-radio custom-control-inline">
      <Field
        type="radio"
        id={`${name}Corp`}
        name={name}
        validate={validate}
        className="custom-control-input"
        component="input"
        value="company"
      />
      <label className="custom-control-label label" htmlFor={`${name}Corp`}>
        a company/organization
      </label>
    </div>
  </div>
);
RenterField.propTypes = {
  name: PropTypes.string.isRequired,
  validate: PropTypes.arrayOf(PropTypes.func).isRequired,
};

export default RenterField;
